var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#007179",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43 0C19.25 0 0 19.25 0 43s19.25 43 43 43c23.747 0 43-19.253 43-43C86 19.25 66.747 0 43 0zm0 80.625C22.22 80.625 5.375 63.78 5.375 43S22.22 5.375 43 5.375 80.625 22.22 80.625 43 63.78 80.625 43 80.625z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.619 27.931-27.65 27.402-11.504-11.277a2.73 2.73 0 0 0-3.838 0 2.665 2.665 0 0 0 0 3.8l13.435 13.166c1.102.97 2.749 1.078 3.837 0l29.56-29.29a2.67 2.67 0 0 0 0-3.8 2.738 2.738 0 0 0-3.84 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.dabcc653ed1fbcc52745a512e15c5f12.svg";
export { ForwardRef as ReactComponent };